import {createSlice,} from '@reduxjs/toolkit';
import {v4} from 'uuid';
import {rtkQueryApi} from '../services/rtkQueryServices';

export interface AuthState {
    uuid: string;
    user: any;
    token: string;
    roll: string;
}

const initialState: AuthState = {
    uuid: '',
    user: null,
    token: '',
    roll: ''
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        resetAuth: (state) => {
            state.token = '';
            state.user = null;
            state.uuid = '';
        },
        distrotJwt: (state) => {
            state.token = state.token + 'sk';
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            rtkQueryApi.endpoints.login.matchFulfilled,
            (state, {payload}) => {
                console.log(payload);
                state.token = payload.jwt;
                state.user = JSON.parse(atob(payload.jwt.split('.')[1]));
                state.uuid = v4();
                state.roll = payload.roll;
            }
        );
        builder.addMatcher(
            rtkQueryApi.endpoints.renewToken.matchFulfilled,
            (state, {payload}) => {
                state.token = payload.jwt;
                state.user = JSON.parse(atob(payload.jwt.split('.')[1]));
                state.uuid = v4();
            }
        );
        builder.addMatcher(rtkQueryApi.endpoints.logout.matchFulfilled, (state) => {
            state.token = '';
            state.user = '';
            state.uuid = '';
        });
        builder.addMatcher(
            rtkQueryApi.endpoints.getAll.matchRejected,
            (state, {payload}) => {
                console.log('matcher', payload);
                if (payload?.status) {
                    if (payload.status === 401) {
                        state.token = '';
                        state.user = '';
                        state.uuid = '';
                        localStorage.setItem('persist:root', '');
                    }
                }
            }
        );
    },
});

export const {resetAuth, distrotJwt} = authSlice.actions;

export default authSlice.reducer;
